import React, { Component } from 'react';
import { connect } from 'react-redux';
// import '../assets/css/theme.css';
import '../../assets/css/theme.css';
import { colors } from '../../assets/Colors';
import { fontText } from '../../assets/fontConstant';
import { Link } from 'react-router-dom';
// import { MainBtn } from '../components/ComponentsCollection';
import logo from '../../assets/images/ClosedStore.png';



 function StoreClose() {

    return (
        <div>
            <div id="content">
                <section className="section pt-0 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 pull-xl-4 col-lg-7 pull-lg-5">
                                <div className="bg-white p-4 p-md-5 mb-4">
                                    <div className="row mb-2 thankyou-maindiv1">
                                        <div className="form-group thankyou-maindiv mb-2">
                                            <img
                                                className="storeclose33"
                                                alt="orderfail"
                                                src={logo}
                                            />
                                        </div>
                                        <div className="form-group thankyou-maindiv mb-2">
                                            <p
                                                className="thankyou-para2 mb-0"
                                                style={{
                                                    // color: colors.primary,
                                                    fontFamily: fontText.NormalText,
                                                }}
                                            >
                                                Sorry, we are closed!
                                            </p>
                                        </div>
                                        <div className="form-group thankyou-maindiv mb-3">
                                            <p
                                                className="mb-0 storeclose34"
                                                style={{ fontFamily: fontText.NormalText }}
                                            >
                                               Our business hours have ended for the day.
                                            </p>
                                        </div>
                                        <div className="form-group thankyou-maindiv mb-2 storeclose-tryagain">
                                            {/* <Link to="/">
                                                <MainBtn name="Try again!" />
                                            </Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
	return {
		storeInfo: state.sessionReducer?.store_details,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		//showCart: () => dispatch(showCart())
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(StoreClose);



